"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var crypto_1 = __importDefault(require("crypto"));
exports.default = (function (length) {
    if (!length) {
        length = 8;
    }
    var urlsafeb64 = function (base64) {
        return base64.replace(/\//g, "_").replace(/\+/g, "-").replace(/[=]/g, "").replace(/^_/, "a");
    };
    return urlsafeb64(crypto_1.default.randomBytes(length).toString("base64"));
});
